import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { MatBottomSheet, MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { CommonUtilService } from '../services/common-util/common-util.service';
import { ToastrService } from 'ngx-toastr';
import { LoaderComponent } from '../common-component/loader/loader.component';
import { RitwikiWithdrawFundsComponent } from './ritwiki-withdraw-funds/ritwiki-withdraw-funds.component';
import { RitwikiRightSliderComponent } from "./ritwiki-right-slider/ritwiki-right-slider.component";
import { RitwikiService } from '../services/raintree/Transmission/ritwiki.service';
import { RitwikPopupComponent } from './ritwik-popup/ritwik-popup.component';
import { ReasonDialogComponent } from './reason-dialog/reason-dialog.component';
@Component({
  selector: 'app-ritwiki',
  standalone: true,
  imports: [CommonModule, RitwikiRightSliderComponent, MatBottomSheetModule, LoaderComponent],
  templateUrl: './ritwiki.component.html',
  styleUrl: './ritwiki.component.scss'
})
export class RitwikiComponent implements OnInit {
  ritwickName: string | null = '';
  currentBalanceInRitwikiAccount: number = 0;
  duration: number = 1500;
  displayBalance: number = 0;
  messageFromApiResponse: string = '';
  isRightSlideVisible: boolean = true;
  isMobileSlideVisible: boolean = false;
  isMobileDevice: boolean = false;
  isLoading: boolean = false;
  pageNo: number = 1;
  pageSize: number = 50;
  recentActivity: any[] = [];
  arrayLength: number = 0;
  checkerForArray: boolean = false;
  isBankDetails: boolean = false;
  isBalanceFailed: boolean = false;
  inValidBalance: boolean = false
  bankDetails: any = []

  constructor(
    private _dialog: MatDialog,
    private _bottomSheet: MatBottomSheet,
    private isMobile: CommonUtilService,
    private _apiService: RitwikiService,
    private toaster: ToastrService,

  ) { }

  ngOnInit(): void {
    this.ritwickName = localStorage.getItem('fullName');
    this.isMobileDevice = this.isMobile.isMobileDevice();
    this.fetchRitwikiBalance();
    // console.log('recent activity...');
    this.fetchRecentActivity();
    // this.animateBalance();
  }

  slideFromRight() {
    this.isRightSlideVisible = !this.isRightSlideVisible;

  }

  onCross() {
    this.isRightSlideVisible = false;
  }

  onDialogOpen() {
    this.isRightSlideVisible = true;
    let screenWidth = window.innerWidth;
    // console.log(screenWidth);

    if (screenWidth <= 600) {
      let sheetRef = this._bottomSheet.open(RitwikiWithdrawFundsComponent, {
        data: {
          amount: this.currentBalanceInRitwikiAccount
        }
      });
      sheetRef.afterDismissed().subscribe(result => {
        if (result) {
          // console.log(result, 'from phone..');
          this._apiService.ritwikiWithdrawAPI({ amount: result.amount, description: result.description }).subscribe({
            next: (response) => {
              // console.log('success', response);
              this.toaster.success(response.message);
              this.fetchRecentActivity();
            }, error: (err) => {
              // console.log('error', err);
              this.toaster.error(err);
            }
          });
        }
      });
    } else {
      let dialogRef = this._dialog.open(RitwikiWithdrawFundsComponent, {
        width: '400px',
        height: '420px',
        data: {
          amount: this.currentBalanceInRitwikiAccount
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.isLoading = true;
          // console.log(result, 'result from web');
          // this._apiService.fetchRitwikiBalanceAPI();
          this._apiService.ritwikiWithdrawAPI({ amount: result.amount, description: result.description }).subscribe({
            next: (response) => {
              // console.log(response, 'success');
              this.toaster.success(response.message);
              this.isLoading = false;
              this.fetchRecentActivity();
            }, error: (err) => {
              // console.log(err, 'error');
              this.toaster.error(err);
              this.isLoading = false;
            }
          });
        }
      });
    }
  }

  hideAndShow() {
    this.isMobileSlideVisible = !this.isMobileSlideVisible
  }

  onCross2() {
    this.isMobileSlideVisible = !this.isMobileSlideVisible
  }

  fetchRitwikiBalance() {
    this.isLoading = true;
    // this.isBalanceFailed = true
    this._apiService.fetchRitwikiBalanceAPI().subscribe({
      next: (response) => {
        this.isBalanceFailed = false
        // console.log(response.data.totalBalance, 'MOney MOney');
        if(!this.isCurrentBalanceInvalid(response.data?.totalBalance)){
          console.log('working');
          
        this.currentBalanceInRitwikiAccount = response.data?.totalBalance;
        this.animateBalance();
        this.inValidBalance = false
      }else{
        this.inValidBalance = true
      }
      this.isBankDetails = response.data.bankDetailsPresent
      this.bankDetails = response.data.bankDetails
      this.isLoading = false;
      }, error: (err) => {
        // console.log(err);
        this.isBalanceFailed = true
        this.isLoading = false;
        this.toaster.error(err);
      }
    });
    
    
  }

isCurrentBalanceInvalid(value: any): boolean {
  const num = Number(value);

  return (
    value == null ||
    value === '' ||
    Number.isNaN(num)
  );
}

  fetchRecentActivity() {
    this.isLoading = true;
    this._apiService.fetchRitwikiPrevReqsAPI({ pageNo: this.pageNo, pageSize: this.pageSize }).subscribe({
      next: (response) => {
        // console.log('success--->', response.data.length);
        if (this.checkerForArray) {
          this.recentActivity = [...this.recentActivity, ...response.data];
        } else {
          this.recentActivity = response.data;
        }
        this.arrayLength = response.data.length;
        this.isLoading = false;
      }, error: (err) => {
        // console.log('Eroor---->', err);
        this.isLoading = false;
      }
    });
  }

  vewAllTxns() {
    if (this.arrayLength < 50) {
      this.toaster.error('no more data to load');
      return;
    } else {
      this.pageNo++;
      this.checkerForArray = true;
      this.fetchRecentActivity();
    }
  }

  animateBalance() {
    const start = 0;
    const end = this.currentBalanceInRitwikiAccount;
    const duration = this.duration;
    const startTime = performance.now();

    const animate = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easedProgress = 1 - Math.pow(1 - progress, 2);
      this.displayBalance = start + (end - start) * easedProgress;
      

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  }

  getAccountDetails(type: string) {
    let screenWidth = window.innerWidth

    if (screenWidth > 600) {
      const dialogRef = this._dialog.open(RitwikPopupComponent, {
        data: {
          type: type,
          isBankDetails: this.isBankDetails,
          details: this.bankDetails
        },
        width: '600px',
        // height: '500px',
      })
      dialogRef.afterClosed().subscribe({
        next: (res)=>{
          if(res){
          this.fetchRitwikiBalance();
            
          }
        }
      })
    } else {

      let sheetRef = this._bottomSheet.open(RitwikPopupComponent, {
        data: {
          type: type,
          isBankDetails: this.isBankDetails,
          details: this.bankDetails
        },
      })
      sheetRef.afterDismissed().subscribe({
        next: (res) => {
          if(res){
            this.fetchRitwikiBalance()
          }
        }
      })
    }
  }

  viewReason(item: any){
    const dialogRef = this._dialog.open(ReasonDialogComponent, {
      data: item
    })
  }
}
